import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import Swal from 'sweetalert2';

const SocketContext = createContext();

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);
    const [token, setToken] = useState(localStorage.getItem('token'));

    // Listen for login/logout to refresh token state
    useEffect(() => {
        const checkToken = () => {
            const currentToken = localStorage.getItem('token');
            if (currentToken !== token) {
                setToken(currentToken);
            }
        };

        // Check frequently and on storage events
        const interval = setInterval(checkToken, 2000);
        window.addEventListener('storage', checkToken);

        return () => {
            clearInterval(interval);
            window.removeEventListener('storage', checkToken);
        };
    }, [token]);

    useEffect(() => {
        if (!token) {
            if (socket) {
                socket.disconnect();
                setSocket(null);
            }
            return;
        }

        const socketUrl = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"
            ? 'http://localhost:3000'
            : 'https://www.cradleai.net';

        const newSocket = io(socketUrl, {
            auth: { token },
            transports: ['websocket'],
        });

        newSocket.on('connect', () => {
            console.log('✅ Connected to Admin Socket');
        });

        // Listen for real-time session termination
        newSocket.on('session_terminated', (data) => {
            Swal.fire({
                title: 'Session Terminated',
                text: data.message || 'Your session has been terminated by an administrator.',
                icon: 'warning',
                confirmButtonColor: '#d33',
                confirmButtonText: 'Login Again',
                allowOutsideClick: false,
            }).then(() => {
                localStorage.removeItem('token');
                window.location.href = '/auth/login';
            });
        });

        newSocket.on('connect_error', (err) => {
            console.error('❌ Socket Connection Error:', err.message);
            if (err.message === "Authentication error: Invalid or terminated session") {
                // Fallback catch for invalid tokens on connection
                localStorage.removeItem('token');
                window.location.href = '/auth/login';
            }
        });

        setSocket(newSocket);

        return () => {
            if (newSocket) newSocket.disconnect();
        };
    }, [token]);

    return (
        <SocketContext.Provider value={socket}>
            {children}
        </SocketContext.Provider>
    );
};
